export const AI_INVENTORY_DRIVER_STEP_HEADER = 'ai-inventory-guest-step-header'
export const AI_INVENTORY_DRIVER_STEP_NEW = 'ai-inventory-guest-step-new'
export const AI_INVENTORY_DRIVER_STEP_SEARCH = 'ai-inventory-guest-step-search'
export const AI_INVENTORY_DRIVER_STEP_TABLE = 'ai-inventory-guest-step-table'

export const AI_INVENTORY_GUEST_DRIVER_STEPS = [
  {
    element: `#${AI_INVENTORY_DRIVER_STEP_HEADER}`,
    popover: {
      title: 'Bem-vindo ao Inventário de IA',
      description:
        'Aqui você registra e acompanha todas as Inteligências Artificiais utilizadas pelo seu departamento. Use este tutorial sempre que precisar relembrar como utilizar a tela.',
    },
  },
  {
    element: `#${AI_INVENTORY_DRIVER_STEP_NEW}`,
    popover: {
      title: 'Cadastrar nova Inteligência Artificial',
      description:
        'Clique em Nova IA para registrar uma Inteligência Artificial utilizada pelo seu departamento. Você poderá escolher entre o <strong>cadastro guiado pela DAI</strong> — mais rápido e simples — ou o <strong>cadastro manual</strong>, preenchendo você mesmo cada etapa.',
    },
  },
  {
    element: `#${AI_INVENTORY_DRIVER_STEP_SEARCH}`,
    popover: {
      title: 'Pesquisar',
      description:
        'Pesquise rapidamente pelo nome para localizar o registro que precisa.',
    },
  },
  {
    element: `#${AI_INVENTORY_DRIVER_STEP_TABLE}`,
    popover: {
      title: 'Seus inventários',
      description:
        'Aqui estão listadas todas as Inteligências Artificiais que você cadastrou. Use o menu de ações para visualizar ou editar cada registro.',
    },
  },
]

export default AI_INVENTORY_GUEST_DRIVER_STEPS
